<template>
  <div id="coaching">
    <v-fab-transition>
      <v-btn
        color="primary"
        fab
        large
        dark
        class="v-btn--open-dialog"
        @click="parametersDialog = !parametersDialog"
        style="z-index: 100"
      >
        <v-icon v-if="!parametersDialog">keyboard_arrow_right</v-icon>
        <v-icon v-if="parametersDialog">keyboard_arrow_left</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="parametersDialog" max-width="600px">
      <v-card class="mx-auto" max-width="1000">
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-domain"
                  v-model="companies"
                  :items="uniqueCompanies"
                  label="Companies"
                  @change="getCoaching"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="search"
                  v-model="coachingNames"
                  :items="uniqueCoachingNames"
                  label="Course names"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="isAdminRole">
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-account-multiple"
                  v-model="participants"
                  :items="uniqueParticipants"
                  label="Participants"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-menu
                  v-model="from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fromDate"
                      label="From"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    @input="from = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="to"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="toDate"
                      label="To"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    @input="to = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="parametersDialog = !parametersDialog"
                color="red"
                dark
                >Close</v-btn
              >
              <div class="flex-grow-1"></div>
              <v-btn @click="drawCharts()" color="info">Update</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container style="width: 100%; max-width: 960px">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <p class="text-center display-1 primary--text">Coaching feedback</p>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Rate</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="rateLoaded"
                      :chartdata="dataCollectionRate"
                      :options="chartOptionsRate"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Benefitted</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="BenefittedLoaded"
                      :chartdata="dataCollectionBenefitted"
                      :options="chartOptionsBenefitted"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Connected</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="connectedLoaded"
                      :chartdata="dataConnected"
                      :options="chartOptionsConnected"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Actions</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="actionsLoaded"
                      :chartdata="dataCollectionActions"
                      :options="chartOptionsActions"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Expectations</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="expectationsLoaded"
                      :chartdata="dataCollectionExpectations"
                      :options="chartOptionsExpectations"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Recommend</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="recommendLoaded"
                      :chartdata="dataCollectionRecommend"
                      :options="chartOptionsRecommend"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Key takeaway from the session</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>

              <v-data-table
                :headers="takewaySessionHeader"
                :items="takewaySessionData"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Improve this service</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>

              <v-data-table
                :headers="improveServiceHeader"
                :items="improveServiceData"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Comments or feedback</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>

              <v-data-table
                :headers="commentsFeedbackHeader"
                :items="commentsFeedbackData"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>


      <!-- <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Tabular data</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>

              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="tableData"
                :search="search"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-flex> -->
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import DefaultLayout from "@/layouts/DefaultLayout";
import { SurveyCoaching } from "../classes/SurveyCoaching";
import PieChart from "@/components/chartjs/PieChart";
import moment from "moment";

export default {
  name: "WorkshopDashboard",
  async created() {
    this.$emit(`update:layout`, DefaultLayout);

    const surveyCoaching = new SurveyCoaching();
    await surveyCoaching.getGraphData();
    this.uniqueCompanies = await surveyCoaching.getUniqueCompanyNames();
    this.uniqueCompanies.unshift("All");
    this.uniqueParticipants = await surveyCoaching.getUniqueCoach();
    this.uniqueParticipants.unshift("All");
    // this.uniqueCoachingNames = await surveyCoaching.getUniqueCoachingNames();
    this.uniqueCoachingNames.unshift("All");

    // const surveyCoaching = new SurveyCoaching();
    // this.uniqueCompanies = await surveyCoaching.getUniqueCompanyNames();
    // this.uniqueCompanies.unshift("All");
    // this.uniqueParticipants = await surveyCoaching.getUniqueCoach();
    // this.uniqueParticipants.unshift("All");
    // this.uniqueCoachingNames = await surveyCoaching.getUniqueCoachingNames();
    // this.uniqueCoachingNames.unshift("All");
    this.drawCharts();
  },
  components: {
    PieChart,
  },
  data: () => ({
    loading: false,
    graphData: {},
    // graphDataTable: [],
    dataCollectionRate: {},
    chartOptionsRate: {},
    rateLoaded: false,

    dataCollectionBenefitted: {},
    chartOptionsBenefitted: {},
    BenefittedLoaded: false,

    dataConnected: {},
    chartOptionsConnected: {},
    connectedLoaded: false,

    dataCollectionActions: {},
    chartOptionsActions: {},
    actionsLoaded: false,

    dataCollectionExpectations: {},
    chartOptionsExpectations: {},
    expectationsLoaded: false,

    dataCollectionRecommend: {},
    chartOptionsRecommend: {},
    recommendLoaded: false,

    parametersDialog: false,
    loading: false,
    uniqueCompanies: [],
    uniqueParticipants: [],
    uniqueCoachingNames: [],
    from: false,
    fromDate: null,
    to: false,
    toDate: null,
    participants: "All",
    service: "All",
    participantsLoaded: false,
    companies: "All",
    coachingNames: "All",

    search: "",
    headers: [
      {
        text: "Coach",
        value: "coach",
      },
      { text: "Feedback", value: "feedback" },
    ],
    tableData: [],
    headers: [],
    takewaySessionData: [],
    takewaySessionHeader: [
      {
        text: "",
        value: "data",
      },
    ],
    improveServiceData: [],
    improveServiceHeader: [
      {
        text: "",
        value: "data",
      },
    ],
    commentsFeedbackData: [],
    commentsFeedbackHeader: [
      {
        text: "",
        value: "data",
      },
    ],
  }),
  methods: {
    async drawCharts() {
      this.parametersDialog = false;
      this.loading = true;
      let filter = null;
      let query = [];

      if (this.companies && this.companies !== "All") {
        query.push({ company: { contains: this.companies } });
      }

      if (this.participants && this.participants !== "All") {
        query.push({ participants: { contains: this.participants } });
      }

      if (this.coachingNames && this.coachingNames !== "All") {
        query.push({ name: { contains: this.coachingNames } });
      }

      if (this.fromDate && this.toDate) {
        const from = moment(this.fromDate).toISOString();
        const to = moment(this.toDate).toISOString();
        query.push({
          date: {
            between: [from, to],
          },
        });
      }

      if (!this.isAdminRole) {
        Auth.currentAuthenticatedUser().then((user) => {
          filter = {};
          query.push({ participants: { contains: user.attributes.email } });

          query.forEach((q) => {
            Object.assign(filter, q);
          });
        });
      } else {
        if (query.length > 0) {
          filter = {};
          query.forEach((q) => {
            Object.assign(filter, q);
          });
        }
      }

      const surveyCoaching = new SurveyCoaching(filter);
      surveyCoaching.getGraphData().then((result) => {
        this.graphData = result;
        this.rateChart();
        this.benefittedChart();
        this.connectedChart();
        this.actionChart();
        this.expectationsChart();
        this.recommendChart();

        this.tableData = [];
        this.graphData.map((data) => {
          this.tableData.push({
            coach: data.participants,
            feedback: data.feedback,
          });
        });

        this.takewaySessionData = [];
        this.graphData.map((data) => {
          if (data.takeway) {
            this.takewaySessionData.push({
              data: data.takeway,
            });
          }
        });

        this.improveServiceData = [];
        this.graphData.map((data) => {
          if (data.improve) {
            this.improveServiceData.push({
              data: data.improve,
            });
          }
        });

        this.commentsFeedbackData = [];
        this.graphData.map((data) => {
          if (data.feedback) {
            this.commentsFeedbackData.push({
              data: data.feedback,
            });
          }
        });

        this.loading = false;
      });
    },
    async rateChart() {
      let dd = {
        excellent: 0,
        verygood: 0,
        good: 0,
        average: 0,
        poor: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.rateCoaching] = (count[data.rateCoaching] || 0) + 1;
        return count;
      }, {});
      dd.excellent = d.excellent;
      dd.verygood = d.verygood;
      dd.good = d.good;
      dd.average = d.average;
      dd.poor = d.poor;
      this.rateLoaded = true;
      this.chartOptionsRate = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionRate = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["excellent", "verygood", "good", "average", "poor"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.excellent, dd.verygood, dd.good, dd.average, dd.poor],
          },
        ],
      };
    },
    async benefittedChart() {
      let dd = {
        stronglyagree: 0,
        agree: 0,
        unsure: 0,
        disagree: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.benefitted] = (count[data.benefitted] || 0) + 1;
        return count;
      }, {});
      dd.stronglyagree = d.stronglyagree;
      dd.agree = d.agree;
      dd.unsure = d.unsure;
      dd.disagree = d.disagree;
      this.BenefittedLoaded = true;
      this.chartOptionsBenefitted = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionBenefitted = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["stronglyagree", "agree", "unsure", "disagree"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.stronglyagree, dd.agree, dd.unsure, dd.disagree],
          },
        ],
      };
    },
    async connectedChart() {
      let dd = {
        stronglyagree: 0,
        agree: 0,
        unsure: 0,
        disagree: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.connected] = (count[data.connected] || 0) + 1;
        return count;
      }, {});
      dd.stronglyagree = d.stronglyagree;
      dd.agree = d.agree;
      dd.unsure = d.unsure;
      dd.disagree = d.disagree;
      this.connectedLoaded = true;
      this.chartOptionsConnected = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataConnected = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["stronglyagree", "agree", "unsure", "disagree"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.stronglyagree, dd.agree, dd.unsure, dd.disagree],
          },
        ],
      };
    },
    async actionChart() {
      let dd = {
        stronglyagree: 0,
        agree: 0,
        unsure: 0,
        disagree: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.actions] = (count[data.actions] || 0) + 1;
        return count;
      }, {});
      dd.stronglyagree = d.stronglyagree;
      dd.agree = d.agree;
      dd.unsure = d.unsure;
      dd.disagree = d.disagree;
      this.actionsLoaded = true;
      this.chartOptionsActions = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionActions = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["stronglyagree", "agree", "unsure", "disagree"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.stronglyagree, dd.agree, dd.unsure, dd.disagree],
          },
        ],
      };
    },
    async expectationsChart() {
      let dd = {
        stronglyagree: 0,
        agree: 0,
        unsure: 0,
        disagree: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.expectations] = (count[data.expectations] || 0) + 1;
        return count;
      }, {});
      dd.stronglyagree = d.stronglyagree;
      dd.agree = d.agree;
      dd.unsure = d.unsure;
      dd.disagree = d.disagree;
      this.expectationsLoaded = true;
      this.chartOptionsExpectations = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionExpectations = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["stronglyagree", "agree", "unsure", "disagree"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.stronglyagree, dd.agree, dd.unsure, dd.disagree],
          },
        ],
      };
    },
    async recommendChart() {
      let dd = {
        stronglyagree: 0,
        agree: 0,
        unsure: 0,
        disagree: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.recommend] = (count[data.recommend] || 0) + 1;
        return count;
      }, {});
      dd.stronglyagree = d.stronglyagree;
      dd.agree = d.agree;
      dd.unsure = d.unsure;
      dd.disagree = d.disagree;
      this.recommendLoaded = true;
      this.chartOptionsRecommend = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionRecommend = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["stronglyagree", "agree", "unsure", "disagree"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.stronglyagree, dd.agree, dd.unsure, dd.disagree],
          },
        ],
      };
    },
    async getCoaching() {
      const surveyCoaching = new SurveyCoaching(null);
      await surveyCoaching.getGraphData();
      this.uniqueCoachingNames = await surveyCoaching.getUniqueCoachingNames(this.companies);
      this.uniqueCoachingNames.unshift("All");
    }
  },
  computed: {
    async isAdminRole() {
      const user = await Auth.currentAuthenticatedUser();
      const awsGroups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      if (awsGroups) {
        const roles =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        return roles.includes("ADMIN");
      }
    },
  },
};
</script>
<style scoped>
.v-btn--open-dialog {
  top: 90px;
  position: fixed;
  margin: 0 0 16px 16px;
}
.navbar-link {
  text-decoration: none !important;
}
.v-toolbar {
  height: 20px !important;
}
</style>